module.exports = __webpack_public_path__ + "img/zhangjinsong.2e6b7a98.png";